export const mutations = {
  SET_LIST(state, payload) {
    state.list = payload
  }
};
